import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shopping-list-detail',
  templateUrl: './shopping-list-detail.component.html',
  styleUrls: ['./shopping-list-detail.component.scss']
})
export class ShoppingListDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
